<template>
  <div class="content">
    <base-block class="mb-0" rounded title="Add State">
      <div class="row">
        <div class="col-md-6 form-group">
          Name
          <input
            @focus="nameEmpty = false"
            class="form-control"
            type="text"
            v-model="name"
          />
          <div class="form-group text-danger" v-if="nameEmpty">
            Name is required
          </div>
        </div>
      </div>
      <div class="text-center">
        <b-button
          class="text-center pt-2 pb-2 pr-4 pl-4"
          variant="success"
          style="margin-bottom: 20px"
          @click="saveChanges()"
          >Save Changes</b-button
        >
      </div>
    </base-block>
  </div>
</template>

<script>
import axios from "axios";
export default {
  data() {
    return {
      nameEmpty: false,
      name: "",
      id: ""
    };
  },
  mounted() {
    this.loadData();
  },
  methods: {
    async loadData() {
      await axios
        .get(
          `${this.$store.getters.baseUrl}/state/edit/${this.$route.params.id}`,
          {
            headers: { Authorization: `Bearer ${this.$store.getters.token}` },
          }
        )
        .then((response) => {
          this.name = response.data.state.name
          this.id = response.data.state.id
        })
        .catch((error) => {
          console.log(error);
        });
    },
    async saveChanges() {
      const formdata = new FormData();
      formdata.append("name", this.name);
      await axios
        .post(
          `${this.$store.getters.baseUrl}/state/update/${this.id}`,
          formdata,
          {
            headers: {
              Authorization: `Bearer ${this.$store.getters.token}`,
            },
          }
        )
        .then((response) => {
          if (this.name == "") {
            this.nameEmpty = true;
            return;
          }
          if (response.data.status == "success") {
            console.log(response);
            this.$swal("Success", "State updated successfully", "success");
            this.$router.push({name: 'Tables States'});
            this.name = "";
          } else {
            this.$swal("Error", "Error while updating state", "warning");
          }
        })
        .catch((error) => {
          console.log(error);
          this.$swal("Error", "Error while updating state", "error");
        });
    },
  },
};
</script>

